import React, { PropsWithChildren } from "react";
import { Text } from "../../general/Text";
import { GlobalStore } from "../../../store/global/GlobalStore";

export const DetailsRightColumnText = ({
  children,
}: PropsWithChildren<{ isSlippageText?: boolean }>) => {
  const theme = GlobalStore.useState(s => s.theme);
  const disabledTextColor = theme.font.primary.default;
  return (
    <Text textStyle="Paragraph" size="Large" color={disabledTextColor}>
      {children}
    </Text>
  );
};
